/*
Documentation

compile and export all reducers for this system

*/

import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import system from './reducers/system/system';
import auth from './reducers/auth/auth';
import device from './reducers/device/device';
import company from './reducers/company/company';
import load from './reducers/load/load';
import config from './reducers/config/config';
import tutorial from './reducers/tutorial';
import appointment_templates from './reducers/appointment_templates/appointment_templates';
import automations from './reducers/automations/automations';
import matter_documents from './reducers/matter_documents/matter_documents';
import signing_templates from './reducers/signing_templates/signing_templates';
import email_templates from './reducers/email_templates/email_templates';
import text_templates from './reducers/text_templates/text_templates';

import state from './reducers/state';
import objects from './reducers/objects';

import forms from './reducers/forms';
import divisions from './reducers/divisions';
import users from './reducers/users';
import contact_types from './reducers/contact_types';
import document_center from './reducers/document_center';
import socket from './reducers/socket';

const rootReducer = combineReducers({
    auth,
    system,
    device,
    company,
    load,
    tutorial,
    config,
    users,
    appointment_templates,
    automations,
    matter_documents,
    signing_templates,
    email_templates,
    text_templates,
    forms,
    divisions,
    state,
    objects,
    contact_types,
    document_center,
    socket
})

const store = createStore(rootReducer, applyMiddleware(thunk));;
export default store
